/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("react"),n=require("@progress/kendo-react-common"),s="ActionSheetView",a=e.forwardRef((t,c)=>{const i=e.useRef(null);return e.useImperativeHandle(c,()=>i,[]),e.createElement("div",{ref:i,style:t.style,className:n.classNames("k-actionsheet-view",t.className)},t.children)});a.displayName="ActionSheetView";exports.ActionSheetView=a;exports.ActionSheetViewDisplayName=s;
